import { inject, Injectable, signal } from '@angular/core';
import { EeaGapSurfacewaterPwcScenariosApiService } from './eea-gap-surfacewater-pwc-scenarios.api.service';
import { lastValueFrom, take } from 'rxjs';
import { CropXRegionUI, ResponseCropXRegion } from 'src/app/shared/models/pwc/scenarios.interface';

@Injectable({
  providedIn: 'root'
})
export class EeaGapSurfacewaterPwcScenariosLogicService {

  public cropXRegion: CropXRegionUI[] = [];
  public visible = signal(false);
  public currentRowId = signal<number | undefined>(undefined)
  public crops: string[] = [];
  public kocRange = signal<string | undefined>(undefined);
  private isKd: boolean = false;
  private apiService = inject(EeaGapSurfacewaterPwcScenariosApiService);
  public kocRangeByScheme = signal<{ applicationSchemePk: number, kocRange: string }[]>([]);

  public async getCropsXRegion(geography: string): Promise<void> {
    const source$ = this.apiService.getScenarios(geography).pipe(take(1));
    const responseCropXRegion = await lastValueFrom(source$);
    this.cropXRegion = responseCropXRegion.map(cropXRegion => ({
      ...cropXRegion,
      fullName: `${cropXRegion.crop}-${cropXRegion.region}`
    }));
    this.getCrops();
  }

  private getCrops(): void {
    this.crops = [...new Set(this.cropXRegion.map(cropXRegion => cropXRegion.crop))];
    this.crops = this.crops.sort((a, b) => a.localeCompare(b));
  }

  public getRegionsByCrop(crop: string): CropXRegionUI[] {
    return this.cropXRegion.filter(cropXRegion => cropXRegion.crop === crop);
  }

  public updateKocRange(value: string) {
    this.kocRange.set(value);
  }

  public get GetRangeKoc() {
    return this.kocRange();
  }
  public get GetKocRangeByScheme(): any {
    return this.kocRangeByScheme();
  }

  public getKocRangeByScheme(): { applicationSchemePk: number, kocRange: string }[] {
    return this.kocRangeByScheme();
  }

  public getKocRangeForScheme(applicationSchemePk: number): string | undefined {
    const range = this.kocRangeByScheme().find(item => item.applicationSchemePk === applicationSchemePk);
    return range?.kocRange;
  }

  public addOrUpdateKocRangeByScheme(applicationSchemePk: number, kocRange: string): void {
    const currentRanges = this.kocRangeByScheme();
    const index = currentRanges.findIndex(item => item.applicationSchemePk === applicationSchemePk);
    if (index !== -1) {
      currentRanges[index].kocRange = kocRange;
    } else {
      currentRanges.push({ applicationSchemePk, kocRange });
    }
    this.kocRangeByScheme.set(currentRanges);
  }

}
